import { AdminGuard } from "./services/admin-guard.service";
import { AuthService } from "./services/auth.service";
import { CatalogService } from "./services/catalog.service";
import { PowertrainService } from "./services/powertrain.service";
import { EngineService } from "./services/engine.service";
import { WorkshopService } from "./services/workshop.service";

import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";

import {
  MatButtonModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatInputModule,
  MatFormFieldModule,
  MAT_DATE_LOCALE,
} from "@angular/material";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBarModule } from "@angular/material/snack-bar";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavComponent } from "./nav/nav.component";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { HelpComponent } from "./help/help.component";
import { SupportComponent } from "./support/support.component";
import { WorkshopComponent } from "./workshop/workshop.component";
import { PowertrainComponent } from "./powertrain/powertrain.component";
import { EngineComponent } from "./engine/engine.component";
import { StockComponent } from "./stock/stock.component";
import { SparepartsComponent } from "./spareparts/spareparts.component";
import { TroubleshootingComponent } from "./troubleshooting/troubleshooting.component";
import { CatalogComponent } from "./catalog/catalog.component";
import { SidemenuComponent } from "./sidemenu/sidemenu.component";
import { AccountComponent } from "./account/account.component";
import { MessageService } from "./services/message.service";
import { ConfirmDeleteDialogComponent } from "./dialog/confirm-delete-dialog/confirm-delete-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { StockService } from "./services/stock.service";
import { TroubleshootingService } from "./services/troubleshooting.service";
import { SparepartService } from "./services/sparepart.service";
import { SettingComponent } from "./setting/setting.component";
import { SettingService } from "./services/setting.service";
import { SummaryPipe } from "./pipes/summary.pipe";
import { AuthGuard } from "./services/auth-guard.service";
import { UsersComponent } from "./users/users.component";
import { Enums } from "./common/enums";
import { TokenInterceptor } from "./services/token-interceptor.service";
import { VisitActionsComponent } from "./visit-actions/visit-actions.component";
import { VisitComponent } from "./visit/visit.component";
import { ActionFilterPipe } from "./pipes/action-filter.pipe";
import { OrderComponent } from "./order/order.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { SpinnerInterceptorService } from "./services/spinner-interceptor.service";
import { SpinnerService } from "./services/spinner.service";
import { VisitsComponent } from "./visits/visits.component";
import { UnDoneOrdersComponent } from "./un-done-orders/un-done-orders.component";
import { DateFormatPipe } from "./pipes/date-format.pipe";
import { DoneOrdersComponent } from "./done-orders/done-orders.component";
import { ReminderedOrdersComponent } from "./remindered-orders/remindered-orders.component";
import { OrderPrintComponent } from "./order-print/order-print.component";
import { NgxPrintModule } from "ngx-print";
import { SparePartsInOutComponent } from "./spare-parts-in-out/spare-parts-in-out.component";
import { StoreGuard } from "./services/store-guard.service";
import { ItemInComponent } from "./item-in/item-in.component";
import { ItemOutComponent } from "./item-out/item-out.component";
import { ItemStartComponent } from "./item-start/item-start.component";
import { ItemCheckComponent } from "./item-check/item-check.component";
import { EngineReportComponent } from "./engine-report/engine-report.component";
import { ConfirmCancelChangesDialogComponent } from "./dialog/confirm-cancel-changes-dialog/confirm-cancel-changes-dialog.component";
import { VisitReportComponent } from "./visit-report/visit-report.component";
import { LifeRecordReportVisitComponent } from "./life-record-report-visit/life-record-report-visit.component";
import { LifeRecordReportOrderComponent } from "./life-record-report-order/life-record-report-order.component";
import { ItemCheckReportComponent } from "./item-check-report/item-check-report.component";
import { EngineReportAmraComponent } from "./engine-report-amra/engine-report-amra.component";
import { ItemReportInventoryComponent } from "./item-report-inventory/item-report-inventory.component";
import { NonCompletedOrdersReportComponent } from "./non-completed-orders-report/non-completed-orders-report.component";
import { OrdersComponent } from "./orders/orders.component";
import { AdminVisitsComponent } from "./admin-visits/admin-visits.component";
import { LifeRecordTroubleshootingComponent } from "./life-record-troubleshooting/life-record-troubleshooting.component";
import { CancelOrderComponent } from "./cancel-order/cancel-order.component";
import { PieChartComponent } from "./pie-chart/pie-chart.component";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { BarChartComponent } from "./bar-chart/bar-chart.component";
import { EngineAliasPipe } from "./engine-alias.pipe";
import { ConfirmBigSearchDialogComponent } from "./dialog/confirm-big-search-dialog/confirm-big-search-dialog.component";
import { TroubleshootingqaComponent } from "./troubleshootingqa/troubleshootingqa.component";
import { TroubleshootingqaboxComponent } from "./troubleshootingqabox/troubleshootingqabox.component";
import { QavisitComponent } from './qavisit/qavisit.component';
import { QavisitentryComponent } from './qavisitentry/qavisitentry.component';
import { QavisitauditComponent } from './qavisitaudit/qavisitaudit.component';
import { QavisitreportComponent } from './qavisitreport/qavisitreport.component';
import { QavisitreportnotacceptedComponent } from './qavisitreportnotaccepted/qavisitreportnotaccepted.component';
import { QavisitreportnotacceptedpointsComponent } from './qavisitreportnotacceptedpoints/qavisitreportnotacceptedpoints.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HomeComponent,
    LoginComponent,
    HelpComponent,
    SupportComponent,
    WorkshopComponent,
    PowertrainComponent,
    EngineComponent,
    StockComponent,
    SparepartsComponent,
    TroubleshootingComponent,
    CatalogComponent,
    SidemenuComponent,
    AccountComponent,
    ConfirmDeleteDialogComponent,
    SettingComponent,
    SummaryPipe,
    UsersComponent,
    VisitActionsComponent,
    VisitComponent,
    ActionFilterPipe,
    OrderComponent,
    SpinnerComponent,
    VisitsComponent,
    UnDoneOrdersComponent,
    DateFormatPipe,
    DoneOrdersComponent,
    ReminderedOrdersComponent,
    OrderPrintComponent,
    SparePartsInOutComponent,
    ItemInComponent,
    ItemOutComponent,
    ItemStartComponent,
    ItemCheckComponent,
    EngineReportComponent,
    ConfirmCancelChangesDialogComponent,
    ConfirmBigSearchDialogComponent,
    VisitReportComponent,
    LifeRecordReportVisitComponent,
    LifeRecordReportOrderComponent,
    ItemCheckReportComponent,
    EngineReportAmraComponent,
    ItemReportInventoryComponent,
    NonCompletedOrdersReportComponent,
    OrdersComponent,
    AdminVisitsComponent,
    LifeRecordTroubleshootingComponent,
    CancelOrderComponent,
    PieChartComponent,
    BarChartComponent,
    EngineAliasPipe,
    TroubleshootingqaComponent,
    TroubleshootingqaboxComponent,
    QavisitComponent,
    QavisitentryComponent,
    QavisitauditComponent,
    QavisitreportComponent,
    QavisitreportnotacceptedComponent,
    QavisitreportnotacceptedpointsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    HttpClientModule,
    NgxPrintModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxChartsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    SpinnerService,
    AuthService,
    AuthGuard,
    AdminGuard,
    StoreGuard,
    WorkshopService,
    StockService,
    MessageService,
    EngineService,
    TroubleshootingService,
    StockService,
    PowertrainService,
    SparepartService,
    SettingService,
    CatalogService,
    Enums,
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmDeleteDialogComponent,
    ConfirmCancelChangesDialogComponent,
    ConfirmBigSearchDialogComponent,
  ],
})
export class AppModule {}
